import {Component} from '@angular/core';
@Component({
  selector: 'app-deal-payroll-rates',
  templateUrl: './deal-payroll-rates.component.html',
  styleUrls: ['./deal-payroll-catalog.component.css']
})
export class DealPayrollRatesComponent {}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/deal-payroll-catalog/deal-payroll-rates.component.ts